import $ from "jquery";
import React, { Suspense, useEffect, useState } from 'react';
import { CSVLink } from "react-csv";
import { Link } from "react-router-dom";

import { toast } from "react-toastify";
import PostLoginGetApi from "../../../components/Api/PostLoginGetApi";
import DatePickerV2 from "../../../components/Date/DatePicker-v2";
import DatePickerRange from "../../../components/Date/DatePickerRange";
import init from '../AccessControl/Check';


import { Area, AreaChart, BarChart, CartesianGrid, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import moment from "moment";


var setDatePicker = () => {
    $("#date-div").hide();
    $("#date-range-div").hide();

    $("#fromDate, #toDate, #singleDatePicker").datepicker('setDate', null);


    var v = $("#date-range-data").val();
    if (v === "custom") {
        $("#date-range-div").show();
    }
    else if (v === "all") {
        $("#date-div").attr("style", "display:flex");
    }
}


const VoucherSummary = () => {

    const pageName = "Voucher Summary";
    init(pageName);


    const [reqParam, setReqParam] = useState({});
    const [isFilter, setIsFilter] = useState(false);
    const [history, setHistory] = useState([]);


    // Get Order Summary Report 
    useEffect(() => {
        PostLoginGetApi("report/voucher", reqParam, 2).then((responseJSON) => {
            let response = JSON.stringify(responseJSON);
            response = JSON.parse(response);

            if (response["status"] === 1) {
                let responseData = JSON.stringify(response["data"]);
                responseData = JSON.parse(responseData);


                if (responseData["code"] === 200) {
                    setHistory(responseData["data"]);
                    return;
                }


                toast.error(responseData["messages"].toString());
                return;
            }
        }).catch((err) => {
            console.log(err);
        });


    }, [isFilter, reqParam]);



    // Get Product & Category
    const [brandList, setBrandList] = useState([]);
    useEffect(()=>{
        PostLoginGetApi("voucher/brand", "", 2).then((responseJSON) => {
            let response = JSON.stringify(responseJSON);
            response = JSON.parse(response);

            if (response["status"] === 1) {
                let responseData = JSON.stringify(response["data"]);
                responseData = JSON.parse(responseData);

                if (responseData["code"] === 200) {
                    setBrandList(responseData["data"]);
                }
            }
        }).catch((err) => {
            console.log(err);
        })


    }, []);

    const filterClick = () => {
        $("#filter-toggle-icon").toggleClass("rotate-180");
        $(".custom-btn.filter").toggleClass("active");

        $("#filter-div").toggleClass("need-without-shadow");
        $("#filter-div").toggleClass("no-need-without-shadow");
    }

    const closeClick = () => {
        $("#filter-div").toggleClass("need-without-shadow");
        $("#filter-div").toggleClass("no-need-without-shadow");
    }

    const filter = (isReset = 1) => {
        
        // Date Filter
        var from = "", end = "";

        if (isReset !== 1) {
            const filterType = $("#date-range-data").val();
            if ((!$("#fromDate").val() || !$("#toDate").val()) && filterType === "custom") {
                toast.error('Please enter filter dates.');
                return;
            }


            if (filterType === "all" && !$("#singleDatePicker").val()) {
                toast.error("Please enter filter date.");
                return;
            }
        }

        if ($("#date-range-data").val() === "custom") {
            from = $("#fromDate").val();
            end = $("#toDate").val();

            if (from.length === 0 || end.length === 0) {
                from = "";
                end = "";
            }
            else {
                let nextDate = new Date(end);
                nextDate.setDate(nextDate.getDate() + 1);
                nextDate = nextDate.getFullYear() + "-" + (nextDate.getMonth() + 1) + "-" + nextDate.getDate();
                nextDate = moment(nextDate).format("YYYY-MM-DD");
                end = nextDate;
            }

        }
        else if ($("#date-range-data").val() === "all") {
            const singleDatePicker = $("#singleDatePicker").val();
            if (singleDatePicker.length !== 0) {
                let nextDate = new Date(singleDatePicker);
                nextDate.setDate(nextDate.getDate() + 1);
                nextDate = nextDate.getFullYear() + "-" + (nextDate.getMonth() + 1) + "-" + nextDate.getDate();
                nextDate = moment(nextDate).format("YYYY-MM-DD");

                from = singleDatePicker;
                end = nextDate;
            }
        }


        let brand_id = $("#brand_id").val();
        if( brand_id === "0" ) {
            brand_id = "";
        }
        


        setReqParam({ ...reqParam, from: from, end: end, brand_id: brand_id });
        if (from !== "" || end !== "" ) {
            setIsFilter(true);
        }
    }


    const resetFilterData = () => {
        $("#date-range-data").val("custom");
        $("#fromDate, #toDate, #singleDatePicker").datepicker('setDate', null);
        $("#to-date-picker").val("");
        $("#brand_id").val("0");

        setDatePicker();
        filter(1);
        setIsFilter(false);
    }



    return (
        <Suspense fallback={<div>Loading...</div>}>
            <div className="custom-container w-full h-screen pb-10 font-montserrat flex ">

                
                {/** Left Side */}
                <div className="custom-container-left float-left custom-scroll-auto min-w-[80%] w-full h-screen mb-20 pb-[150px] pr-3 text-justify" style={{ boxShadow: "3px 0 0px 0px rgb(0 0 0 / 1%)" }}>

                    <div className="w-full text-justify rounded-[5px] py-3 pt-2 flex" style={{boxShadow: "0 8px 4px -6px rgba(0, 0, 0, 0.03)"}}>
                        <div className="w-1/2 float-left">
                            <h6 className="text-xl px-4 font-medium pb-0 pl-0 pt-3">Here’s your shop history reports</h6>
                        </div>

                        <div className="w-1/2 h-[68px] float-left text-right justify-end flex items-center">
                            <CSVLink className="custom-btn mr-2 text-center" filename={"order-report.csv"} data={history}>Export CSV</CSVLink>
                            <Link to="#" onClick={filterClick} className="custom-btn filter text-center w-[92px] active">Filter</Link>
                            <svg id="filter-toggle-icon" className='static -ml-4' width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect x="0.5" y="0.5" width="29" height="29" rx="14.5" fill="#1A202C" />
                                <path d="M17 19L13 15L17 11" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                <rect x="0.5" y="0.5" width="29" height="29" rx="14.5" stroke="#F5F5F5" />
                            </svg>
                        </div>

                    </div>


                    <div className='w-full max-w-full h-auto mt-5 mb-5 flex items-center overflow-x-auto'>
                        {(history.length > 0) ? 
                        <table className="table-auto w-full m-auto h-auto mt-2" border={0}>
                            <thead>
                                <tr className='bg-[#F5F5F5] mt-2'>
                                    <td className="mt-2 pt-4 pb-4 rounded-l-md font-semibold text-center" style={{width: "50px"}}>#</td>
                                    <td className="mt-2 pt-4 pb-4 pl-4 font-semibold" style={{width: "150px"}}>Date</td>
                                    <td className="mt-2 pl-4 pt-4 pb-4 font-semibold">Offer Name</td>
                                    <td className="mt-2 pl-4 pt-4 pb-4 font-semibold">Brand Name</td>
                                    <td className="mt-2 pt-4 pb-4 text-center font-semibold" title="Sale Quantity" style={{width: "150px"}}>Quantity</td>
                                    <td className="mt-2 pt-4 pb-4 rounded-r-md text-center font-semibold" style={{width: "200px"}}>Total Price</td>
                                </tr>
                            </thead>
                            <tbody>
                                {history.map((val, index)=>
                                    <tr key={index} className="hover-black-green border-b-2">
                                        <td className="mt-2 pt-4 pb-4 border-r-2 rounded-l-md text-center font-semibold">{index+1}</td>
                                        <td className="mt-2 pt-4 pb-4 pl-4 border-r-2 rounded-r-none">{moment(val.order_date, "YYYY-MM-DD").format("DD MMM, YYYY")}</td>
                                        <td className="mt-2 pt-4 pl-4 pb-4 border-r-2 rounded-r-none">{val.offer_name}</td>
                                        <td className="mt-2 pt-4 pl-4 pb-4 border-r-2 rounded-r-none">{val.brand_name}</td>
                                        <td className="mt-2 pt-4 pb-4 border-r-2 rounded-r-none text-center">{val.quantity}</td>
                                        <td className="mt-2 pt-4 pb-4 rounded-r-md text-center">{val.amount}</td>
                                    </tr>
                                )}
                            </tbody>

                            
                        </table>
                        :
                        <div className="custom-container-left float-left custom-scroll-auto min-w-[80%] w-full h-screen mb-20 pb-[150px] pr-3 text-justify" style={{ boxShadow: "3px 0 0px 0px rgb(0 0 0 / 1%)" }}>
                            <h2 className='py-4 px-2 text-xl'>No voucher report data available</h2>
                        </div>
                        }
                    </div>

                </div>

                

                
                {/** Right Side */}
                <div id="filter-div" style={{ overflowX: "hidden" }} className="custom-container-right custom-scroll-auto h-screen float-right w-1/5 pl-2 pb-10 pt-4 pr-0 justify-center mb-20 need-without-shadow">
                    <div style={{ overflowX: "hidden" }} className="relative custom-scroll-auto">
                        
                        <h6 className="text-lg px-3 font-base pb-2 pl-2 whitespace-nowrap" style={{ boxShadow: "0 3px 0 0 rgb(0 0 0 / 1%)" }}>Filter Report</h6>

                        <div className="relative">
                            <div className="box-full w-full  text-justify py-2 pl-2 pr-1">
                                <div className="w-full float-left pt-2  mb-3">
                                    <select onChange={setDatePicker} id="date-range-data" className='w-full mt-0 mb-4 bg-[#F5F5F5] rounded border-0' defaultValue="custom">
                                        <option value="all">Single Date</option>
                                        <option value="custom">Date Range</option>
                                    </select>
                                    <DatePickerV2 />
                                    <DatePickerRange />
                                </div>
                            </div>

                            <div className="box-full w-full  text-justify py-2 pl-2 pr-1">
                                <div className="w-full float-left">
                                    <select id="brand_id" className='w-full mt-0 mb-4 bg-[#F5F5F5] rounded border-0' defaultValue="0">
                                        <option value="0">All Brands</option>
                                        {(brandList.length === 0) ? (
                                            <></>
                                        ) : (
                                            <>
                                                {brandList.map((val, index) => (
                                                    <option key={index} value={val?.id} >{val?.name}</option>
                                                ))}
                                            </>
                                        )}
                                    </select>
                                </div>
                            </div>

                            <div className="box-full w-full text-justify py-2 pl-3 pr-1 mt-6">
                                <button onClick={filter} className="custom-btn box-full w-full text-center py-1 pl-2 pr-1">Filter</button>

                                {isFilter && <button onClick={resetFilterData} className="custom-btn bg-black text-white border-black mt-3 box-full w-full text-center py-2 pl-2 pr-1" style={{ color: "#FFF" }}>Reset Filter</button>}
                                <button className="hidden mb-close-btn py-2.5 px-5 rounded w-[97%] ml-2 mt-3 bg-red-400 text-white" onClick={closeClick}>Close</button>
                            </div>

                        </div>
                    </div>
                </div>

            </div>

        </Suspense >
    );
};

export default VoucherSummary;